module.exports = __webpack_public_path__ + "img/937ec9556be09ce397967a06e157f476.png";